import leagueInfo from '../../../utils/leagueInfo';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

const baseData = [
  {
    category: 'data',
    element: 'social',
    title: 'Social Post',
    icon: 'fak fa-layout-isolated',
    description: 'Feature live social posts.',
    premium: true,
    limitedElement: ['social-data', 'social-display'],
    maxElements: 1,
    test: 'social',
  },
  {
    category: 'data',
    element: 'sheets',
    title: 'Google Sheets',
    logo: `${TGB_ASSETS_URL}/logos/google/google_sheets_logo.avif`,
    description: 'Display data from Sheets.',
    premium: true,
    test: 'sheets',
  },
];

const sportradarElements = Object.entries(leagueInfo).map(([leagueKey, league]) => ({
  category: 'data',
  element: `sportradar-${leagueKey}`,
  title: league.label,
  icon: 'fak fa-sportradar',
  logo: league.logo,
  description: `${league.label} stats, powered by ${league?.poweredByLabel ?? 'Sportradar'}.`,
  premium: true,
  provider: 'sportradar',
  leagueName: leagueKey,
  test: `sportradar-${leagueKey}`,
}));

const data = [
  ...baseData.filter((item) => !item.element?.startsWith('sportradar')),
  ...sportradarElements,
];

export default data;
